module.exports = __webpack_public_path__ + "img/274328906_4647505845347088_3848981912158830202_n.f37fbaaa.jpg";